import React from 'react';
import { Route, Routes } from 'react-router-dom';

import WhatToExpectPage from '../WhatToExpectPage/WhatToExpectPage';

import SkillsPage from './SkillsPage/SkillsPage';
import CatCareDetailsPage from './CatCareDetailsPage';
import DogCareDetailsPage from './DogCareDetailsPage';
import SitterProfileContent from './SitterProfileContent';

// This is a descendant `<Routes>`: it matches the URL *remainder* after the
// parent route (`/provider-profile/details/*` and the EPSU
// `/provider-profile/existing-provider-sign-up/:serviceSlug/details/*`) has
// matched, so the child paths are relative. The same relative set serves both
// parent mount points, which is why the EPSU block no longer needs its own
// absolute duplicates. (Under v5's react-router-config these were absolute and
// matched the full URL; v6 descendant routing is relative — see routes/index.tsx.)
const SitterProfilePage: React.FC = () => {
  return (
    <Routes>
      <Route path="dog-care-details" element={<DogCareDetailsPage />} />
      <Route path="cat-care-details" element={<CatCareDetailsPage />} />
      <Route path="skills" element={<SkillsPage />} />
      <Route path="what-to-expect" element={<WhatToExpectPage />} />
      <Route index element={<SitterProfileContent />} />
    </Routes>
  );
};

export default SitterProfilePage;
